import Vue from 'vue'

import minifyTheme from 'minify-css-string'
import Vuetify, {
  VAutocomplete,
  VCombobox,
  VSelect,
  VSwitch,
  VTextarea,
  VTextField,
} from 'vuetify/lib'

import i18n from './i18n'

Vue.use(Vuetify, {
  components: {
    VSwitch,
    VSelect,
    VTextField,
    VAutocomplete,
    VCombobox,
    VTextarea,
  },
})

const preset = {
  breakpoint: {
    mobileBreakpoint: 'sm',
    scrollBarWidth: 16,
    thresholds: {
      xs: 0,
      sm: 576,
      md: 768,
      lg: 992,
      xl: 1200,
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {},
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme,
      themeCache: undefined,
    },
    themes: {
      light: {
        primary: {
          base: '#00725B',
          lighten1: '#4DA479',
          lighten2: '#58AC88',
          lighten3: '#6AAA96',
          lighten4: '#96CEB2',
          lighten5: '#B0DAC5',
          darken1: '#004F3F',
          darken2: '#00876C',
        },

        error: { base: '#FF5252' },
        success: { base: '#4CAF50' },
        warning: { base: '#FB8C00' },
        loading: { base: '#a6a6a6' },
        accent: { base: '#82b1ff' },
        colorText: {
          base: '#c0c0c0',
          lighten1: '#F7F7F6',
          darken1: '#757575',
          darken2: '#343A40',
        },
        ['draggable-header']: { base: '#F7F7F6' },
        info: { base: '#2196f3' },
      },
      dark: {
        primary: { base: '#E43924' },
        error: { base: '#FF5252' },
        success: { base: '#4CAF50' },
        warning: { base: '#FB8C00' },
        loading: { base: '#a6a6a6' },
        accent: { base: '#82b1ff' },
        colorText: { base: '#c0c0c0' },
        info: { base: '#2196f3' },
      },
    },
  },
}

export default new Vuetify({
  preset,
})
